<!--=======================================
=            WIDGETSCARDSPARK             =
========================================-->
<template>
  <v-card  class="ml-2 rounded-lg"  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">

    <v-card height="300" color="primary ">
      <v-card-text dark class="white--text subtitle-1 font-weight-black">Sales Statistics</v-card-text>
      <div id="spark1" ></div>
    </v-card>

    <v-card-text  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'"  color="transparent">
      <v-container class="transparent">
        <v-row no-gutters>
          <v-col md="6" cols="12" sm="6">
           <v-card class=" mt-n15 rounded-lg ma-2 mb-13" outlined flat height="140" color="primary darken-1" tile>
              <v-col class="text-center" cols="12">
                <v-list-item-avatar tile size="80" color="primary " class="rounded-lg">
                  <v-icon size="40" dark>
                    home
                  </v-icon>
                </v-list-item-avatar>

                <h4 class="white--text font-weight-black">
                 Organize
                </h4>
              </v-col>

            </v-card>
            <v-card class=" mt-5 rounded-lg ma-2 mb-15" outlined flat height="140" color="primary darken-1" tile>
              <v-col class="text-center" cols="12">
                <v-list-item-avatar tile size="80" color="primary " class="rounded-lg">
                  <v-icon size="40" dark>
                    paid
                  </v-icon>
                </v-list-item-avatar>
                <h4 class="white--text font-weight-black">
                  Payment
                </h4>

              </v-col>
            </v-card>

          </v-col>
          <v-col md="6" cols="12" sm="6">
            <v-card class=" mt-n15 rounded-lg ma-2 mb-13" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" outlined flat height="140" color="primary darken-1" tile>

              <v-col class="text-center" cols="12">

                  <v-list-item-avatar tile size="80" color="primary " class="rounded-lg">
                  <v-icon size="40" dark>
                     calendar_today
                  </v-icon>
                </v-list-item-avatar>

                <h4 class="white--text font-weight-black">
                   Calendar
                </h4>
              </v-col>

            </v-card>
            <v-card class="mt-5 rounded-lg ma-2 mb-13" outlined flat height="140" color="primary darken-1" tile>
             <v-col class="text-center" cols="12">

                <v-list-item-avatar tile size="80" color="primary " class="rounded-lg">
                  <v-icon size="40" dark>
                    favorite_border
                  </v-icon>
                </v-list-item-avatar>

                <h4 class="white--text font-weight-black">
                  Files 
                </h4>
              </v-col>
            
            </v-card>

          </v-col>


        </v-row>
      </v-container>

    </v-card-text>
  </v-card>

</template>
<script>
  export default {
    mounted() {
      var randomizeArray = function (arg) {
        var array = arg.slice();
        var currentIndex = array.length,
          temporaryValue, randomIndex;

        while (0 !== currentIndex) {

          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;

          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }

        return array;
      }

      // data for the sparklines that appear below header area
      var sparklineData = [47, 45, 54, 38, 56, 24, 65, 31, 37, 39, 62, 51, 35, 41, 35, 27, 93, 53, 61, 27, 54, 43, 19,
        46
      ];

      var spark1 = {
        chart: {
          type: 'area',
          height: 240,
          sparkline: {
            enabled: true
          },
        },
        stroke: {
          curve: 'straight'
        },
        fill: {
          opacity: 0.3,
        },
        series: [{
          data: randomizeArray(sparklineData)
        }],
        yaxis: {
          min: 0
        },
        colors: ['#B0E0E6'],
        title: {

        }, tooltip: {
         
          theme:'dark'
        },
        subtitle: {
          text: '',
          offsetX: 0,
          style: {

          }
        }
      }



      var spark1 = new ApexCharts(document.querySelector("#spark1"), spark1);
      spark1.render();

    },
  }
</script>
<style>
  #spark1 {
    width: 360px;
    padding-top: 10px;
    background-color: transparent;


  }

  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }  .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5);
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5);
    background: rgba(0, 0, 0, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }
</style>


<!--====  End of WIDGETSCARDSPARK   ====-->
